import {
    SupportProgramCategory,
    SupportProgramGroup,
    SupportProgramSettings,
    SupportProgramStatistics
} from "@/program/interfaces/Program";
import SupportProgramSettingsService from "@/program/services/SupportProgramSettingsService";

const SupportProgramStatisticsService = () => {
    /**
     * Keys to filter out from support program category to get only the group keys.
     */
    const FILTER_INCLUDED = ['label', 'short', 'total', 'ratio', 'intersection'];

    /**
     * Get the support program group keys from a category. By filter out the keys used for metadata.
     */
    const getSupportProgramGroupKeys = (category: SupportProgramCategory): string[] => {
        return Object.keys(category)
            .filter((key) => !FILTER_INCLUDED.includes(key));
    };

    /**
     * Get the optional groups that are disabled in the settings.
     */
    const optionalDisabledGroups = (statistics: SupportProgramStatistics, settings: SupportProgramSettings) => {
        const includedGroups = getSupportProgramGroupKeys(statistics.included);
        const excludedGroups = getSupportProgramGroupKeys(statistics.excluded);

        const optionalsIncludedGroups = includedGroups.filter((group) => {
            return (statistics.included[group] as SupportProgramGroup)?.optional;
        });

        const optionalsExcludedGroups = excludedGroups.filter((group) => {
            return (statistics.excluded[group] as SupportProgramGroup)?.optional;
        });

        return [
            ...optionalsIncludedGroups.filter((group) => !SupportProgramSettingsService.isInclusionGroupEnabled(settings, group)),
            ...optionalsExcludedGroups.filter((group) => !SupportProgramSettingsService.isExclusionGroupEnabled(settings, group)),
        ];
    };

    return {
        getSupportProgramGroupKeys,
        optionalDisabledGroups
    };
};

export default SupportProgramStatisticsService();
